import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../../context/AuthContext'
import ContactForm from '../../Landing/DemoContact/ContactForm.jsx'

import '../../Landing/DemoContact/ContactForm.css'
import './LandingNav.css'

const LandingNav = ({ showAuthButton = true }) => {
  const { isAuthenticated } = useAuthContext()
  const navigate = useNavigate()
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [isDemoOpen, setIsDemoOpen] = useState(false)

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
  }

  const handleEnterApp = () => {
    console.log('Enter App button clicked')
    // Mark that user has visited the app
    localStorage.setItem('has-visited-app', 'true')
    closeMobileMenu()
    navigate('/app')
  }

  const handleSignIn = () => {
    console.log('Sign In button clicked')
    closeMobileMenu()
    navigate('/auth')
  }

  const handleHome = () => {
    console.log('Home logo clicked')
    closeMobileMenu()
    navigate('/home')
  }

  // Use Contact Form
  const handleBookDemo = () => setIsDemoOpen(true)

  // Smooth scrolling for navigation links
  const handleSmoothScroll = (e, target) => {
    e.preventDefault()
    
    // If we're not on the home page, navigate there first
    if (window.location.pathname !== '/home') {
      navigate('/home')
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.querySelector(target)
        if (element) {
          const headerHeight = 80
          const targetPosition = element.offsetTop - headerHeight
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          })
        }
      }, 100)
    } else {
      // We're already on the home page, just scroll
      const element = document.querySelector(target)
      if (element) {
        const headerHeight = 80
        const targetPosition = element.offsetTop - headerHeight
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        })
      }
    }
  }

  // Handle navigation link clicks
  const handleNavLinkClick = (e, target) => {
    e.preventDefault()
    console.log('Nav link clicked:', target, 'Current path:', window.location.pathname)
    closeMobileMenu()

    // If we're on auth pages, just navigate to home
    if (window.location.pathname.includes('/auth')) {
      console.log('Navigating from auth page to home')
      navigate('/home')
    } else {
      // Otherwise use smooth scroll
      console.log('Using smooth scroll on home page')
      handleSmoothScroll(e, target)
    }
  }

  return (
    <header className="landing-header">
      {/* Hamburger Menu Button - outside nav for positioning */}
      <button
        className={`hamburger-btn ${mobileMenuOpen ? 'open' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle navigation menu"
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      <nav className="landing-nav">
        <div className="logo" onClick={handleHome} style={{ cursor: 'pointer' }}>
          <span>OmniContext AI</span>
        </div>

        <ul className="nav-links">
          <li>
            <a
              href="#features"
              onClick={(e) => handleNavLinkClick(e, '#features')}
            >
              Features
            </a>
          </li>
          <li>
            <a
              href="#use-cases"
              onClick={(e) => handleNavLinkClick(e, '#use-cases')}
            >
              Use Cases
            </a>
          </li>
        </ul>

        {showAuthButton && (
          <div className="nav-buttons">
            {isAuthenticated ? (
              <button onClick={handleEnterApp} className="nav-btn nav-btn-primary">
                Sign In
              </button>
            ) : (
              <button onClick={handleSignIn} className="nav-btn nav-btn-primary">
                Sign In
              </button>
            )}
            <button onClick={handleBookDemo} className="nav-btn nav-btn-secondary">
              Book a Demo
            </button>
            <ContactForm isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
          </div>
        )}
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}
        onClick={closeMobileMenu}
      ></div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-nav-links">
          <li>
            <a
              href="#features"
              onClick={(e) => handleNavLinkClick(e, '#features')}
            >
              Features
            </a>
          </li>
          <li>
            <a
              href="#use-cases"
              onClick={(e) => handleNavLinkClick(e, '#use-cases')}
            >
              Use Cases
            </a>
          </li>
        </ul>

        {showAuthButton && (
          <div className="mobile-nav-buttons">
            {isAuthenticated ? (
              <button onClick={handleEnterApp} className="nav-btn nav-btn-primary mobile-nav-btn">
                Sign In
              </button>
            ) : (
              <button onClick={handleSignIn} className="nav-btn nav-btn-primary mobile-nav-btn">
                Sign In
              </button>
            )}
            <button onClick={handleBookDemo} className="nav-btn nav-btn-secondary mobile-nav-btn">
              Book a Demo
            </button>
            <ContactForm isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
          </div>
        )}
      </div>
    </header>
  )
}

export default LandingNav
